import React from 'react';
import { Link } from 'react-router-dom';
import classes from './AlternateMessageDialog.module.scss';
import MainButton from '../buttons/MainButton';
import TextButton from '../buttons/TextButton/TextButton';
import { buttonVariants } from '../buttons/types';

export default function AlternateMessageDialog(props) {
  const {
    title,
    icon,
    headerLabel,
    startTracking,
    mainButtonLabel,
    mainButtonEvent,
    textButtonLabel,
    textButtonHandler,
    isApprover,
    placementStatus,
    headerClasses = '',
    containerClasses = '',
    mainContainerClasses = ''
  } = props;

  return (
    <>
      {title && (
        <div className={classes.header}>
          <h1 className={classes.title}>{title}</h1>
        </div>
      )}

      <div className={`${mainContainerClasses} ${classes.emptyPageContainer}`}>
        <div className={`${containerClasses} ${!isApprover ? classes.container : classes.approvercontainer}`}>
          <p>{icon}</p>
          <h5 className={headerClasses}>{headerLabel}</h5>
          <h6>{startTracking}</h6>
          <div className={!isApprover ? classes.linkcontainer : classes.approverlinkcontainer}>
            {mainButtonEvent && (
              <div className="pt-4">
                <MainButton
                  sx={{ width: '220px', height: '40px ' }}
                  action={mainButtonEvent}
                  rounded
                  forceWidth="max-content"
                  size="small"
                  variant={buttonVariants.PRIMARY}
                >
                  {mainButtonLabel}
                </MainButton>
              </div>
            )}
            {!isApprover && (
              <Link to={textButtonHandler}>
                <TextButton>{textButtonLabel}</TextButton>
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
